<template>
  <div class="document-detail">
    <div class="document-detail-head" v-if="!isPreview">
      <button class="document-detail-caption" @click="openDetail(item.id)" target="_blank">別ウインドウで開く</button>
      <div class="document-detail-icon-wrap">
        <button class="document-detail-icon ga-precedent-detail-print" @click="printTarget('document-detail-body')"><span class="tip">印刷</span><FontawesomeIcon class="icn ga-precedent-detail-print" :icon="['far','print']" /></button>
        <button class="document-detail-icon"
          v-if="!isFromAdminSystem()"
          @click="clickNote"
          ><span class="tip">ノートに保存</span><IcnNote class="icn svg-inline--fa" /></button>
      </div>
    </div>
    <div id="document-detail-body" class="document-detail-body" ref="detailBody">
      <FontawesomeIcon v-if="isLoading" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
      <template v-else>
        <div class="document-detail-body-head">
        <span class="document-detail-body-caption">{{item.typeMainText}}</span>
        <template v-if="item.typeText === '判例'">
          <div class="document-detail-body-caption-detail-wrap">
            <p class="document-detail-body-caption-detail" v-if="item.date"><strong>裁判年月日</strong><strong>:</strong><span>{{ item.date }}</span></p>
            <p class="document-detail-body-caption-detail" v-if="item.saibansyoText"><strong>裁判所</strong><strong>:</strong><span>{{ item.saibansyoText }}</span></p>
            <p class="document-detail-body-caption-detail" v-if="item.case_name"><strong>事件番号</strong><strong>:</strong><span>{{ item.case_name }}</span></p>
            <p class="document-detail-body-caption-detail" v-if="item.source"><strong>出典</strong><strong>:</strong><span>{{ item.source }}</span></p>
          </div>
        </template>
        <template v-else>
          <div class="document-detail-body-caption-detail-wrap">
            <p class="document-detail-body-caption-detail" v-if="item.date"><strong>年月日</strong><strong>:</strong><span>{{ item.date }}</span></p>
            <p class="document-detail-body-caption-detail"><strong>発翰番号</strong><strong>:</strong><span>{{item.hakkanText}}<template v-if="item.hakkan1">{{ item.hakkan1 }}</template></span></p>
          </div>
        </template>
      </div>
      <div class="document-detail-body-section" v-if="item.sub_text">
        <p v-if="item.sub_title" class="mb20">{{ item.sub_title }}</p>
        <p class="document-detail-body-title"><span class="text">要旨</span></p>
        <div class="document-detail-body-text" v-html="item.sub_text"></div>
      </div>
      <div class="document-detail-body-section" v-if="item.text">
        <p class="document-detail-body-title"><span class="text">内容</span></p>
        <div class="document-detail-body-text" v-html="item.text"></div>
      </div>
      </template>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, computed, onMounted } from '@vue/composition-api'
import { openPrecedentDetail } from '@/logic/common/CommonPrecedent'
import store from '@/store'
import { isFromAdminSystem } from '@/util/common'

export default defineComponent({
  props: {
    item: {
      type: Object,
      default: undefined
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {

    onMounted(() => {
      // console.log('Scrolltop: ' + context.refs.detailBody.scrollTop)
      // console.log('WindowScrolltop: ' + window.scrollY)
      context.refs.detailBody.scroll({ top: 0, behavior: 'smooth' })
      window.scrollTo(0, 0)
    })

    const state = reactive({
      visibleNoteSelect: false,
      detailId: computed(() => store.state.precedent.detailId),
      detailName: computed(() => store.state.precedent.themeName)
    })

    const openDetail = (detailId) => {
      openPrecedentDetail(detailId)
    }

    const clickNote = () => {
      context.emit('clickNote')
    }

    return {
      state,
      openDetail,
      clickNote,
      isFromAdminSystem
    }
  }
})
</script>

<style lang="scss" scoped>

</style>
